// This plugin is used to add data attributes for GTM tracking (as requested by CRO)
// As of 03/16/2018, I collaborated with Markus Schuette (CRO Analyst) to produce
// the strategy behind this file (it is a work in progress).
//
// It does the following:
// - applies "data-brand=[brand name]" attributes to links which contain URL parts (see 'brandToUrlMap' object)
// - applies "data-element=[Image|Text Link|Click To Call]" to respective CTA elements

import { hasClass, containsStr } from './_utilities';

// data attributes to add
const dataAttributes = {
    dataBrand: 'data-brand',
    dataElement: 'data-element',
    dataComponent: 'data-component',
};

// list of brand strings (to set as value for data-brand='')
const brandMap = {
    att: 'AT&T',
    buckeyeBroadband: 'Buckeye Broadband',
    cableOne: 'Cable ONE',
    centurylink: 'CenturyLink',
    charter: 'Charter',
    cox: 'Cox',
    directv: 'DIRECTV',
    dish: 'DISH',
    frontier: 'Frontier',
    googleFiber: 'Google Fiber',
    grande: 'Grande Communications',
    optimum: 'Optimum',
    mediacom: 'Mediacom',
    rcn: 'RCN',
    spectrum: 'Spectrum',
    suddenlink: 'Suddenlink',
    timeWarner: 'Time Warner Spectrum',
    verizon: 'Verizon',
    viasat: 'Viasat',
    windstream: 'Windstream',
    wave: 'Wave',
    wow: 'WOW!',
    xfinity: 'Xfinity',
};

// href/url strings (values) used to associate to brand name (via brandMap)
// NOTE: these url parts do NOT need to be the entire URL, but must be unique
// as they are used to associated them with the brand name
const brandToUrlMap = {
    att: ['attsavings.com', '/go/att'],
    buckeyeBroadband: ['/buckeye-broadband', '/go/buckeye-broadband'],
    cableOne: ['/cable-one', 'cableone.net', '/go/cable-one'],
    centurylink: ['centurylinkquote.com', '/centurylink', '/go/centurylink'],
    charter: ['/charter'],
    cox: ['/cox', '/go/cox'],
    directv: ['usdirect.com', 'directvplans.com', '/go/directv'],
    dish: ['usdish.com', '/dish', '/go/dish'],
    frontier: ['go.frontier.com', '/frontier', '/go/frontier'],
    googleFiber: ['fiber.google.com', '/go/google-fiber'],
    grande: ['ordergrande.com', '/go/grande'],
    optimum: [
        '/optimum',
        'ad.doubleclick.net/ddm/clk/450880876',
        '/go/optimum',
    ],
    mediacom: ['/mediacom', '/go/mediacom'],
    rcn: ['/rcn', '/go/rcn'],
    spectrum: ['/spectrum', '/go/spectrum'],
    suddenlink: ['suddenlink.com', '/go/suddenlink'],
    timeWarner: ['/time-warner'],
    verizon: ['verizonspecials.com', 'verizon.com', '/go/verizon'],
    viasat: ['viasatspecials.com', '/go/viasat'],
    xfinity: ['xfinity.ulvh.net', '/go/xfinity'],
    wow: ['wow-specials.com', '/go/wow'],
    wave: ['buywavebroadband.com', '/go/wave'],
    windstream: ['ad.doubleclick.net/ddm/clk/444147463', '/go/windstream'],
};

// loops through 'brandToUrlMap' and checks each value for the tagHrefPart string
// then uses its key to match the key in brandMap to return the brand string
const checkBrandtoUrlMap = (tagHrefPart, objStrings) => {
    let brandName = null;

    for (const str in objStrings) {
        // loop through properties
        if (Object.prototype.hasOwnProperty.call(objStrings, str)) {
            /* eslint-disable */
            objStrings[str].forEach((item) => {
                if (containsStr(tagHrefPart, item)) {
                    // console.log('tagHrefPart: ' + tagHrefPart + ', found: ' + item + ', brand: ' + brandMap[str]);
                    brandName = brandMap[str];
                }
            });
            /* eslint-enable */
        }
    }

    return brandName;
};

// initializes the loading of adding all tracking data attributes
const loadTracking = () => {
    $(document).ready(() => {
        // add 'data-brand' to anchor tags where 'href' substring matches any string in 'urlPartArray'
        const ctaAnchorTags = [];
        const anchorTags = document.getElementsByTagName('a');
        let tagHrefPart = '';
        Array.prototype.map.call(anchorTags, (a) => {
            tagHrefPart = a.getAttribute('href');

            // data-brand='[brand string]'
            if (tagHrefPart) {
                // console.log('tagHrefPart checked: ', tagHrefPart);
                const brand = checkBrandtoUrlMap(tagHrefPart, brandToUrlMap);
                if (brand) {
                    // console.log('brand returned:', brand);
                    a.setAttribute(dataAttributes.dataBrand, brand);
                }
            }

            // data-element='Button'
            if (hasClass(a, 'button') || a.className.indexOf('button') >= 0) {
                a.setAttribute(dataAttributes.dataElement, 'Button');
            }

            // data-element='Image' or data-element='Click To Call' or data-element='TextLink'
            if (
                tagHrefPart &&
                !hasClass(a, 'button') &&
                !a.hasAttribute('data-element')
            ) {
                if (a.firstElementChild !== null) {
                    if (a.firstElementChild.tagName !== null) {
                        if (a.firstElementChild.tagName === 'IMG') {
                            a.setAttribute(dataAttributes.dataElement, 'Image'); // Image
                        }
                    }
                } else {
                    /* eslint-disable */
                    if (containsStr(tagHrefPart, 'tel:')) {
                        a.setAttribute(
                            dataAttributes.dataElement,
                            'Click To Call'
                        ); // Click To Call
                        ctaAnchorTags.push(a); // save these to add data-brand='' attribute later
                    } else {
                        a.setAttribute(dataAttributes.dataElement, 'Text Link'); // TextLink
                    }
                    /* eslint-enable */
                }
            }
        });

        // get all components on page and tag its internal links with the component's ID/Name string
        const components = document.querySelectorAll('[data-component]');
        let componentId = '';

        for (let i = 0; i < components.length; i++) {
            componentId = components[i].getAttribute('data-component');
            // console.log('component found:', componentId);

            // get anchor tags within component
            const componentAnchorTags = components[i].getElementsByTagName('a');

            /* eslint-disable */
            Array.prototype.map.call(componentAnchorTags, (a) => {
                // data-component='[componentId]'
                a.setAttribute(dataAttributes.dataComponent, componentId);
            });
            /* eslint-enable */
        }

        // add 'data-brand' to anchor tags in "Click to Call" CTAs where current
        // page location matches the URL string in brandToUrlMap()
        const pageUrlPathArray = window.location.pathname.split('/');

        Array.prototype.map.call(ctaAnchorTags, (a) => {
            const urlPart = `/${pageUrlPathArray[1]}`;
            // console.log('urlPart:', urlPart);
            const brand = checkBrandtoUrlMap(urlPart, brandToUrlMap);
            if (brand) {
                // console.log('brand returned:', brand);
                a.setAttribute(dataAttributes.dataBrand, brand);
            }
        });
    });
};

// module startup
const init = () => {
    loadTracking();
};

export { init, brandMap };
